import {
  createImage,
  createCanvasPhoto,
  createCanvasCarousel
} from '../../fbApi/Image';
import { createVideo, createCanvasVideo, createVideoForAccount } from '../../fbApi/Videos';
import { createCanvasButton } from '../../fbApi/Button';
import { createCanvasProductSet } from '../../fbApi/ProductSet';
import { createCanvas } from '../../fbApi/Canvas';
import { createCanvasFooter } from '../../fbApi/Footer';

export const buildImage = async (params, photo) => {
  const parameters = {
    id: `${params.pageId  }/photos`,
    url: photo
  };

  const result = await createImage(parameters, params.token);
  return result.id;
};

export const buildVideo = async (params, video) => {
  const parameters = {
    accountId: params.accountId,
    id: `${params.pageId  }/videos`,
    file_url: video
  };

  const result = await createVideo(parameters, params.token);

  if (result.error && result.error.message === 'You have been temporarily blocked from performing this action.') {
    console.log('buildVideo failed, trying to create video for account...')
    const resultVideoForAccount = await createVideoForAccount(parameters, params.accessToken);
    return resultVideoForAccount.id;
  }
  
  return result.id;
};

export const buildCanvasPhoto = async (params, photo) => {
  const photoId = await buildImage(params, photo.url);

  const parameters = {
    id: `${params.pageId  }/canvas_elements`,
    canvas_photo: {
      name: photo.name,
      photo_id: photoId,
      open_url_action: { type: 'OPEN_URL', url: photo.imageTargetUrl },
      style: getStyle(photo.radioFit)
    }
  };

  const result = await createCanvasPhoto(parameters, params.token);
  return result.id;
};

export const buildCanvasFooter = async (params) => {
  const parameters = {
    id: `${params.pageId  }/canvas_elements`,
    canvas_footer: {
      name: params.footerName,
      child_elements: params.child_elements
    }
  };

  const result = await createCanvasFooter(parameters, params.token);
  return result.id;
};

export const buildCanvasButton = async (params) => {
  const parameters = {
    id: `${params.pageId  }/canvas_elements`,
    canvas_button: {
      open_url_action: { url: params.destinationUrl },
      name: params.buttonName,
      rich_text: { plain_text: params.buttonText }
    }
  };

  const result = await createCanvasButton(parameters, params.token);
  return result.id;
};

export const buildCanvasProductSet = async (params) => {
  const parameters = {
    id: `${params.pageId  }/canvas_elements`,
    canvas_product_set: {
      product_set_id: params.product_set_id,
      name: params.productSetName,
      item_headline: params.headline,
      item_description: params.description,
      show_in_feed: true
    }
  };

  const result = await createCanvasProductSet(parameters, params.token);
  return result.id;
};

export const getStyle = (style) => {
  switch (style) {
    case 'FitToWidth':
      return 'FIT_TO_WIDTH';
    case 'FitToWidthTappable':
      return 'FIT_TO_WIDTH_EXPANDABLE';
    case 'FitToHeight':
      return 'FIT_TO_HEIGHT';
    default:
      return 'FIT_TO_WIDTH';
  }
};

export const buildCanvasVideo = async (params, video) => {
  const videoId = params.videoId
    ? params.videoId
    : await buildVideo(params, video.url);

  const parameters = {
    id: `${params.pageId  }/canvas_elements`,
    canvas_video: {
      name: video.name,
      video_id: videoId,
      style: getStyle(video.radioFitVideo)
    }
  };

  const result = await createCanvasVideo(parameters, params.token);
  return result.id;
};

export const buildCanvasCarousel = async (params, carousel) => {
  const canvasPhotos = await Promise.all(
    carousel.cards.map(async (photo) => {
      photo.radioFit = carousel.radioFitCarousel;
      return Promise.resolve(await buildCanvasPhoto(params, photo));
    })
  );

  const parameters = {
    id: `${params.pageId  }/canvas_elements`,
    canvas_carousel: {
      name: carousel.name,
      style: getStyle(carousel.radioFitCarousel),
      child_elements: canvasPhotos
    }
  };

  const result = await createCanvasCarousel(parameters, params.token);
  return result.id;
};

export const buildCanvas = async (
  params,
  elements,
  name,
  theme,
  enableSwipe
) => {
  const parameters = {
    id: `${params.pageId  }/canvases`,
    bodyElements: elements,
    name,
    theme,
    is_published: params.is_published,
    enable_swipe_to_open: enableSwipe
  };

  const result = await createCanvas(parameters, params.token);
  return result.id;
};



// WEBPACK FOOTER //
// ./src/screens/Canvas/CanvasCreator.js